import { render } from "./OrderValidationTab.vue?vue&type=template&id=748785b7&scoped=true"
import script from "./OrderValidationTab.vue?vue&type=script&lang=js"
export * from "./OrderValidationTab.vue?vue&type=script&lang=js"

import "./OrderValidationTab.vue?vue&type=style&index=0&id=748785b7&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748785b7"]])

export default __exports__